import { Component, inject } from '@angular/core';
import { RegisterValueService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RegisterValueCreateDto,
  RegisterValueDto,
  RegisterValueExcelDownloadDto,
  RegisterValueUpdateDto,
} from '../proxy/planning/dtos/register-value';
import { REGISTERVALUE_CONFIG, REGISTERVALUE_FIELDS } from './register-value.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-register-value',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RegisterValueService, ConfirmationService],
  templateUrl: './register-value.html',
  styleUrl: './register-value.scss',
})
export class RegisterValue extends BaseCrudComponent<
  RegisterValueDto,
  RegisterValueCreateDto,
  RegisterValueUpdateDto,
  RegisterValueExcelDownloadDto
> {
  service = inject(RegisterValueService);
  config = REGISTERVALUE_CONFIG;
  fields = REGISTERVALUE_FIELDS;

  protected prepareUpdateDto(data: any, selected: RegisterValueDto): RegisterValueUpdateDto {
    return {
      deedValue: data.deedValue,
      fiscalValue: data.fiscalValue,
      valueDate: data.valueDate,
      isLastValue: data.isLastValue,
      registerId: data.registerId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RegisterValue';
  }
}
